module.exports = __webpack_public_path__ + "static/media/be.645a21cb.svg";